import { makeStyles } from '@material-ui/core/styles';

import { DataGridCellStylesProps } from './DataGridCell.types';

export const useStyles = makeStyles(theme => ({
  title: {
    ...theme.typography.h6,
  },
  description: {
    color: theme.palette.gray.light,
    ...theme.typography.h6,
    textAlign: 'left',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    marginBottom: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 0.25 : 0.5),
  },
  icon: {
    width: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 1.25 : 1.375),
    height: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 1.25 : 1.375),
    marginRight: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 0.5625 : 0),
    marginLeft: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 0 : 1),

    '& .MuiSvgIcon-root': {
      width: ({ withTitle }: DataGridCellStylesProps) => theme.spacing(withTitle ? 1.25 : 2),
      height: 'auto',

      '& .background_color': {
        fill: theme.palette.gray.dark,
      },
    },
  },
}));
